<div class="align-v-center mr-20 ph-5 pointer hover-background-primary" (click)="reset()">
  <i class="fa fas fa-sign-out {{viewPortService.isMobile ? 'ic-primary' : 'ic-white'}} transform-180 fs-big"></i>
  <div class="fs-big ml-10 mv-5 {{viewPortService.isMobile ? 'c-secondary' : 'c-white'}}">End client session</div>
</div>
